import { useLocation, useNavigate } from "react-router-dom";
import special from "../styles/special.module.scss";

function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();
  const pathLabel = location.pathname || "/";

  const visualStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(8, 12, 12, 0.12), rgba(8, 12, 12, 0.84)), url(${process.env.PUBLIC_URL}/images/contact.jpg)`,
  };

  return (
    <div className={`${special.contactShell} ${special.notFoundShell}`}>
      <div className={`${special.contactPage} ${special.notFoundPage}`}>
        <div className={special.contactBackdrop}></div>
        <div className={`${special.contactFrame} ${special.notFoundFrame}`}>
          <div className={special.contactVisual} style={visualStyle}>
            <div className={special.contactVisualOverlay}></div>
            <div className={special.contactVisualCopy}>
              <p className={special.contactVisualEyebrow}>Page not found</p>
              <h2>This route does not exist.</h2>
              <p>
                <code>{pathLabel}</code> is not a Matlib page. Sign in or return
                to the library if you already have a session.
              </p>
            </div>
          </div>

          <div className={special.contactForm}>
            <h1>Nothing here</h1>
            <p className={special.contactIntro}>
              Check the URL, or use one of the links below to get back into the
              app.
            </p>
            <div className={special.contactActions}>
              <button
                type="button"
                className={special.registerSecondaryButton}
                onClick={() => navigate("/")}
              >
                Sign in
              </button>
              <button
                type="button"
                className={special.contactButton}
                onClick={() => navigate("/library")}
              >
                Back to library
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
